import React from 'react';

export const linkifyEmail = (text: string): React.ReactNode => {
  const emailRegexGlobal = /([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})/gi;
  const emailRegexSingle = /^([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})$/i;
  const parts = text.split(emailRegexGlobal);

  if (parts.length === 1) {
    return text;
  }

  return (
    <>
      {parts.map((part, idx) => {
        if (emailRegexSingle.test(part)) {
          const email = part;
          return (
            <a key={idx} href={`mailto:${email}`}>
              {email}
            </a>
          );
        }

        return <React.Fragment key={idx}>{part}</React.Fragment>;
      })}
    </>
  );
};
